import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import dateFormat from 'dateformat';
import { isSameDay } from 'site-modules/shared/utils/date-utils';

export function ArticleDateline({
  published = null,
  updated = null,
  updatedLabel = null,
  publishedClassName = null,
  textClassName = 'small',
}) {
  const showUpdatedDate = !!updated && new Date(updated) > new Date(published) && !isSameDay(updated, published);

  return (
    <Fragment>
      {showUpdatedDate ? (
        <span
          className={classnames('d-inline-block', textClassName, publishedClassName)}
          itemProp="dateModified"
          content={updated}
        >
          {updatedLabel}
          {dateFormat(updated, 'm/d/yyyy')}
        </span>
      ) : (
        <span
          className={classnames('d-inline-block', textClassName, publishedClassName)}
          itemProp="datePublished"
          content={published}
        >
          {dateFormat(published, 'm/d/yyyy')}
        </span>
      )}
    </Fragment>
  );
}

ArticleDateline.propTypes = {
  published: PropTypes.string,
  updated: PropTypes.string,
  updatedLabel: PropTypes.string,
  textClassName: PropTypes.string,
  publishedClassName: PropTypes.string,
};
